import Vue from 'vue'
import Vuex from 'vuex'

import im from './modules/im'
import question from './modules/question'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    home: 0, // 主页/入口： 1.精灵、2.IM、3.工单首页、4.我的工单
    imStatus: null, // IM会话的状态: 1.waiting 2.chatting
    imEntranceMode: 0, // 1.统一入口 2.多入口
    companyName:"" ,// 公司名称
  },
  actions: {

  },
  mutations: {
    setHome  (state, obj) {
      state.home = obj.home
    },

   setImStatus (state, obj) {
      state.imStatus = obj.status
    },

   setEntranceMode (state, obj) {
      state.imEntranceMode = obj.imEntranceMode
    },
    setCompanyName(state, companyName) {
      state.companyName = companyName
    }
  },
  getters: {
    home(state) {
      return state.home
    },

    imStatus(state) {
      return state.imStatus
    },
    getCompanyName (state) {
      return state.companyName
    },

  imEntranceMode(state) {
    console.error("get imEntranceMode : " + state.imEntranceMode)
    return state.imEntranceMode
  }
},
modules: {
  im,
  question
}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js